import styled from "styled-components";

export const SearchWrapper = styled.div`
  position: relative;
  margin-bottom: 24px;
`;

export const LocationsFlex = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
  gap: 12px;
`;

const locationItem = `
    border-radius: 8px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    color: #666;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    cursor: pointer;
  
    svg {
      width: 16px;
      height: 16px;
      fill: #666666;
    }
`;

export const LocationItem = styled.button`
  ${locationItem};

  border: 1px solid #c5c5c5;
  background: #fff;
`;

export const LocationItemActive = styled.button`
  ${locationItem};

  border: 1px solid #408bfc;
  background: #f3f8ff;

  svg {
    fill: #408bfc;
  }

  &:hover {
    border-color: #ff2727;
    background: #fdf4f4;

    svg {
      fill: #ff2727;
    }
  }
`;

export const Label = styled.label`
  color: #666;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  display: block;
  margin-bottom: 8px;
`;
